// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Refresh Table Button Component should match snapshot 1`] = `
<Memo(Button)
  className="refreshTableBtn"
  icon="refresh"
  key="refresh-table"
  onClick={[Function]}
  title="Refresh Table"
  type="default"
/>
`;
